import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
  Table,
  CardHeader,
  CardText,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import SeasonAction from "store/season-resource/actions"
import FabricInventoryAction from "store/fabric-inventory-resource/actions"
import TableContainer from "components/tables/TableContainer"

export default function DetailFabricInventory() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      companyName: "",
      bunch: "",
      brand: "",
      number: "",
      actualInventory: 0,
      allocation: 0,
      theoreticalStock: 0,
      needRestock: true,
      currentOrderQuantity: 0,
      adjustmentQty: 0,
      orders: [
        {
          orderNumber: "",
          scale: 0,
          orderDate: "2023-04-01",
        },
      ],
    },
    validationSchema: Yup.object({
      adjustmentQty: Yup.number().required("必須項目です。"),
    }),
    onSubmit: values => {
      dispatch(
        FabricInventoryAction.putData(
          { adjustmentQty: values.adjustmentQty, id: params.id },
          callbackPut
        )
      )
    },
  })

  const callbackPost = () => {
    history.push("/inventory-control/fabric-inventory-management")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/inventory-control/fabric-inventory-management")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(
        FabricInventoryAction.getDetail({ id: params.id }, callbackGetDetail)
      )
    }
  }, [params.id])

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="生地在庫管理 詳細" breadcrumbList={[]} />

          <Card body>
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <Col sm="12">
                  <Label>ブランド</Label>
                  <p>{store?.fabricInventory?.detail?.data?.brand}</p>
                </Col>
                <Col sm="12">
                  <Label>バンチ</Label>
                  <p>{store?.fabricInventory?.detail?.data?.bunch}</p>
                </Col>
                <Col sm="12">
                  <Label>生地番号</Label>
                  <p>{store?.fabricInventory?.detail?.data?.number}</p>
                </Col>

                <Col sm="12" className="mt-3">
                  <Table bordered striped>
                    <thead>
                      <tr>
                        <td>実在個数</td>
                        <td>引き当て</td>
                        <td>理論在庫</td>
                        <td>発注済数</td>
                        <td>数量調整</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {
                            store?.fabricInventory?.detail?.data
                              ?.actualInventory
                          }
                        </td>
                        <td>
                          {store?.fabricInventory?.detail?.data?.allocation}
                        </td>
                        <td>
                          {store?.fabricInventory?.detail?.data
                            ?.actualInventory >
                            store?.fabricInventory?.detail?.data?.allocation &&
                            "▲"}
                          {
                            store?.fabricInventory?.detail?.data
                              ?.theoreticalStock
                          }
                        </td>
                        <td>
                          {
                            store?.fabricInventory?.detail?.data
                              ?.currentOrderQuantity
                          }
                        </td>
                        <td>
                          <Input
                            name="adjustmentQty"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.adjustmentQty}
                            invalid={
                              validation.errors.adjustmentQty ? true : false
                            }
                          />
                          {validation.errors.adjustmentQty ? (
                            <FormFeedback type="invalid">
                              {validation.errors.adjustmentQty}
                            </FormFeedback>
                          ) : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col sm="3">
                  <div>取り扱ってる生地商社</div>
                  <Input
                    value={store?.fabricInventory?.detail?.data?.companyName}
                    disabled
                  />
                </Col>
                <Col sm="12" className="d-flex justify-content-end mt-2">
                  <Button type="submit" className="button">
                    保存
                  </Button>

                  <Button
                    type="button"
                    className="ms-2 button"
                    onClick={() =>
                      history.push(
                        "/inventory-control/fabric-inventory-management"
                      )
                    }
                  >
                    キャンセル
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
          <Card body>
            <CardText>引き当て在庫</CardText>
            {store.fabricInventory.detail.loading ? (
              <LoadingComponent />
            ) : (
              <TableContainer
                data={store?.fabricInventory?.detail?.data?.orders || []}
                columns={[
                  {
                    Header: "日付",
                    accessor: "orderDate",
                    defaultCanSort: false,
                  },
                  {
                    Header: "受注番号",
                    accessor: "orderNumber",
                    defaultCanSort: false,
                  },
                  {
                    Header: "用尺",
                    accessor: "scale",
                    defaultCanSort: false,
                  },
                ]}
              />
            )}
          </Card>
        </Container>
      </div>
    </>
  )
}
